"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { FlexCenter, NumberDisplay, SpaceBetween, TextBody, TextBodySkeleton } from "@opensea/ui-kit";
import { LocalGasStationFilled } from "@opensea/ui-kit/icons";
import { BigNumber } from "@opensea/utils";
import { useTranslations } from "use-intl";
import { SwapDetailsGasFeeItemFragment } from "./SwapDetailsGasFeeItem.fragment";
export const SwapDetailsGasFeeItem = t0 => {
  const $ = _c(11);
  const {
    swapRoute: swapRouteKey
  } = t0;
  const swapRoute = readFragment(SwapDetailsGasFeeItemFragment, swapRouteKey);
  const t = useTranslations("wallet.SwapDetailsGasFeeItem");
  if (!swapRoute || swapRoute.__typename !== "SwapRoute") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SwapDetailsGasFeeItemSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const gasFeeUsd = BigNumber.sum(...swapRoute.costs.filter(_temp).map(_temp2));
  if (gasFeeUsd.isZero() || gasFeeUsd.isNaN()) {
    return null;
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("gasFee");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <FlexCenter className="gap-1"><TextBody>{t1}</TextBody></FlexCenter>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LocalGasStationFilled fill="text-secondary" size={20} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== gasFeeUsd) {
    t4 = <FlexCenter className="gap-1.5">{t3}<TextBody asChild={true}><NumberDisplay display="usd" value={gasFeeUsd} /></TextBody></FlexCenter>;
    $[6] = gasFeeUsd;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <SpaceBetween>{t2}{t4}</SpaceBetween>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
const SwapDetailsGasFeeItemSkeleton = () => {
  const $ = _c(7);
  const t = useTranslations("wallet.SwapDetailsGasFeeItem");
  let t0;
  if ($[0] !== t) {
    t0 = t("gasFee");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FlexCenter className="gap-1.5"><LocalGasStationFilled fill="text-secondary" size={20} /><TextBodySkeleton className="w-[50px]" /></FlexCenter>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <SpaceBetween>{t1}{t2}</SpaceBetween>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(c) {
  return c.costType === "GAS";
}
function _temp2(c_0) {
  return c_0.cost.usd;
}